import React, { useState } from 'react';
import FeedbackListElement from './FeedbackListElement.js';

import './CheckListElement.css';

import TypeTag from '../tags/TypeTag.js';
import MedicTag from '../tags/MedicTag.js';
import ImpactAttributeTag from '../tags/ImpactAttributeTag.js';

const key = process.env.REACT_APP_CLIENT_ACCESS_KEY;
const URLS = require("../../../urls.js");

const StatusCodes = require('../../../status-codes/status-codes.js')
const ErrorCodes = require('../../../error-codes/error-codes.js')

const CheckListElement = ({ checkData, onButtonClick }) => {
    const [overriddenStatus, setOverriddenStatus] = useState(checkData.manual_override);

    const handleButtonClick = () => {
        setOverriddenStatus(prevStatus => {
            const newStatus = prevStatus ? 0 : 1;
    
            let checkToUpdate = {
                checkFlagData: checkData,
                overriddenStatus: newStatus,
                objectType: 'check'
            };
            onButtonClick(checkToUpdate);
    
            return newStatus;
        });
    
        console.log('overriddenStatus changed');
    };

    return (
        <FeedbackListElement
            testType={checkData.test_type}
            impactAttribute={checkData.impact_attribute}
            testName={checkData.test_name}
            result={checkData.result}
            issueMessage={checkData.issue_message}
            failureMode={checkData.failure_mode}
            overriddenStatus={overriddenStatus}
        >
            {checkData.impact_attribute === 'info' && (
                <div className="element-value">
                    Info
                </div>
            )}

            {checkData.impact_attribute === 'check' && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {checkData.result === 0 && (
                        <button className="enter-button" onClick={handleButtonClick}>
                            {overriddenStatus ? 'Reinstate' : 'Override'}
                        </button>
                    )}
                    <div className="element-value" style={{ color: checkData.result ? '#29ba46' : '#e83838' }}>
                        {checkData.result ? 'Passed' : 'Failed'}
                    </div>
                </div>
            )}
        </FeedbackListElement>
    );
};

export default CheckListElement;